import {
  ArrowLeftIcon,
  BuildingsIcon,
  ChartLineUpIcon,
  EnvelopeSimpleIcon,
  GearIcon,
  GraduationCapIcon,
  ShieldIcon,
  UserPlusIcon,
  UsersIcon,
} from '@phosphor-icons/react';

import { Sidebar } from '@/shared/shell/Sidebar';
import { SidebarBrand } from '@/shared/shell/SidebarBrand';
import { SidebarNavItem, SidebarSectionLabel } from '@/shared/shell/SidebarNavItem';
import { SidebarUserMenu } from '@/shared/shell/SidebarUserMenu';

/** Admin sidebar — same chrome as the team app shell (brand + sectioned nav + user footer). */
export function AdminSidebar() {
  return (
    <Sidebar
      header={
        <SidebarBrand
          icon={<ShieldIcon size={16} weight="fill" className="text-white" />}
          title="zooid admin"
          subtitle="Admin console"
        />
      }
      footer={<SidebarUserMenu />}
    >
      <nav className="flex flex-col gap-4">
        <div className="flex flex-col gap-0.5">
          <SidebarNavItem to="/app" icon={ArrowLeftIcon} label="Back to app" />
        </div>

        <div className="flex flex-col gap-0.5">
          <SidebarSectionLabel>Insights</SidebarSectionLabel>
          <SidebarNavItem to="/admin" end icon={ChartLineUpIcon} label="Overview" />
        </div>

        <div className="flex flex-col gap-0.5">
          <SidebarSectionLabel>People</SidebarSectionLabel>
          <SidebarNavItem to="/admin/users" icon={UsersIcon} label="Users" />
          <SidebarNavItem to="/admin/teams" icon={BuildingsIcon} label="Teams" />
        </div>

        <div className="flex flex-col gap-0.5">
          <SidebarSectionLabel>Beta</SidebarSectionLabel>
          <SidebarNavItem to="/admin/invitations" icon={EnvelopeSimpleIcon} label="Invitations" />
          <SidebarNavItem to="/admin/beta-requests" icon={UserPlusIcon} label="Join requests" />
        </div>

        <div className="flex flex-col gap-0.5">
          <SidebarSectionLabel>System</SidebarSectionLabel>
          <SidebarNavItem to="/admin/skills" icon={GraduationCapIcon} label="Skills" />
          <SidebarNavItem to="/admin/settings" icon={GearIcon} label="Settings" />
        </div>
      </nav>
    </Sidebar>
  );
}
